import userContext from 'yc-user-context'
const lang = {
  // 英语
  enus: {
    '请选择': 'select',
    '确定': 'ok',
    '更多': 'more',
    '收起': 'collapse',
    '展开': 'open',
    '暂无数据': 'no data',
    '限': 'limited to',
    '字': 'words',
    '还可输入': 'can also input',
    '取消': 'cancel',
    '删除': 'delete',
    '提示': 'tip',
    '清空': 'clear',
    '校验失败！': 'validate error!',
    '上一页': 'prev',
    '下一页': 'next',
    '每页显示': 'show',
    '共': 'total',
    '跳至': 'to',
    '页': 'pages',
    '条': 'lists',
    '暂无匹配数据': 'no data',
    '详细': 'Details',
    '日': 'Sun',
    '一': 'Mon',
    '二': 'Tue',
    '三': 'Wed',
    '四': 'Thu',
    '五': 'Fri',
    '六': 'Sat',
    '年': 'Year',
    '1月': 'Jan',
    '2月': 'Feb',
    '3月': 'Mar',
    '4月': 'Apr',
    '5月': 'May',
    '6月': 'Jun',
    '7月': 'Jul',
    '8月': 'Aug',
    '9月': 'Sep',
    '10月': 'Oct',
    '11月': 'Nov',
    '12月': 'Dec',
    '一月': 'Jan',
    '二月': 'Feb',
    '三月': 'Mar',
    '四月': 'Apr',
    '五月': 'May',
    '六月': 'Jun',
    '七月': 'Jul',
    '八月': 'Aug',
    '九月': 'Sep',
    '十月': 'Oct',
    '十一月': 'Nov',
    '十二月': 'Dec',
    '加载中...': 'Loading...'
  },
  // 繁体
  zhtw: {
    '请选择': '請選擇',
    '确定': '確定',
    '更多': '更多',
    '收起': '收起',
    '展开': '展開',
    '暂无数据': '暫無數據',
    '限': '限',
    '字': '字',
    '还可输入': '還可輸入',
    '取消': '取消',
    '删除': '删除',
    '提示': '提示',
    '清空': '清空',
    '校验失败！': '校驗失敗！',
    '上一页': '上壹頁',
    '下一页': '下壹頁',
    '每页显示': '每頁顯示',
    '共': '共',
    '跳至': '跳至',
    '页': '頁',
    '条': '條',
    '暂无匹配数据': '暫無匹配數據',
    '详细': '詳細',
    '日': '日',
    '一': '一',
    '二': '二',
    '三': '三',
    '四': '四',
    '五': '五',
    '六': '六',
    '年': '年',
    '1月': '1月',
    '2月': '2月',
    '3月': '3月',
    '4月': '4月',
    '5月': '5月',
    '6月': '6月',
    '7月': '7月',
    '8月': '8月',
    '9月': '9月',
    '10月': '10月',
    '11月': '11月',
    '12月': '12月',
    '一月': '一月',
    '二月': '二月',
    '三月': '三月',
    '四月': '四月',
    '五月': '五月',
    '六月': '六月',
    '七月': '七月',
    '八月': '八月',
    '九月': '九月',
    '十月': '十月',
    '十一月': '十一月',
    '十二月': '十二月',
    '加载中...': '載入中...'
  },
  // 日语
  jajp: {
    '请选择': '選択してください',
    '确定': 'を選択して、',
    '更多': '詳細',
    '收起': 'やめる',
    '展开': 'てんかい',
    '暂无数据': 'データが一時的にありません',
    '限': '制限',
    '字': 'ワード',
    '还可输入': '入力も可能',
    '取消': 'キャンセル',
    '删除': '削除＃サクジョ＃',
    '提示': 'ヒント',
    '清空': 'クリアランス',
    '校验失败！': '検証に失敗しました！',
    '上一页': '前のページ',
    '下一页': '次のページ',
    '每页显示': 'ページごとに表示',
    '共': '合計',
    '跳至': 'ジャンプ先',
    '页': 'ページ＃ページ＃',
    '条': 'バー',
    '暂无匹配数据': '一致データが一時的にありません',
    '详细': '詳細',
    '日': '日',
    '一': '一',
    '二': '二',
    '三': '三',
    '四': '四',
    '五': '五',
    '六': '六',
    '年': '年',
    '1月': '1月',
    '2月': '2月',
    '3月': '3月',
    '4月': '4月',
    '5月': '5月',
    '6月': '6月',
    '7月': '7月',
    '8月': '8月',
    '9月': '9月',
    '10月': '10月',
    '11月': '11月',
    '12月': '12月',
    '一月': '1月',
    '二月': '2月',
    '三月': '3月',
    '四月': '4月',
    '五月': '5月',
    '六月': '6月',
    '七月': '7月',
    '八月': '8月',
    '九月': '9月',
    '十月': '10月',
    '十一月': '11月',
    '十二月': '12月',
    '加载中...': 'ロード中...'
  },
  // 越南语
  vivn: {
    '请选择': 'Vui lòng chọn',
    '确定': 'Đồng ý',
    '更多': 'Thêm',
    '收起': 'Thu gọn',
    '展开': 'Mở rộng',
    '暂无数据': 'Không có dữ liệu',
    '限': 'Giới hạn',
    '字': 'ký tự',
    '还可输入': 'Có thể nhập thêm',
    '取消': 'Hủy',
    '删除': 'Xóa',
    '提示': 'Thông báo',
    '清空': 'Làm sạch',
    '校验失败！': 'Xác thực thất bại!',
    '上一页': 'Trang trước',
    '下一页': 'Trang sau',
    '每页显示': 'Hiển thị mỗi trang',
    '共': 'Tổng cộng',
    '跳至': 'Đến',
    '页': 'trang',
    '条': 'bản ghi',
    '暂无匹配数据': 'Không tìm thấy dữ liệu phù hợp',
    '详细': 'Chi tiết',
    '日': 'CN',
    '一': 'T2',
    '二': 'T3',
    '三': 'T4',
    '四': 'T5',
    '五': 'T6',
    '六': 'T7',
    '年': 'năm',
    '1月': 'Thg 1',
    '2月': 'Thg 2',
    '3月': 'Thg 3',
    '4月': 'Thg 4',
    '5月': 'Thg 5',
    '6月': 'Thg 6',
    '7月': 'Thg 7',
    '8月': 'Thg 8',
    '9月': 'Thg 9',
    '10月': 'Thg 10',
    '11月': 'Thg 11',
    '12月': 'Thg 12',
    '一月': 'Tháng 1',
    '二月': 'Tháng 2',
    '三月': 'Tháng 3',
    '四月': 'Tháng 4',
    '五月': 'Tháng 5',
    '六月': 'Tháng 6',
    '七月': 'Tháng 7',
    '八月': 'Tháng 8',
    '九月': 'Tháng 9',
    '十月': 'Tháng 10',
    '十一月': 'Tháng 11',
    '十二月': 'Tháng 12',
    '加载中...': 'Đang tải...'
  },
  // 法语
  frfr: {
    '请选择': 'Sélectionner',
    '确定': 'OK',
    '更多': 'Plus',
    '收起': 'Réduire',
    '展开': 'Déplier',
    '暂无数据': 'Aucune donnée',
    '限': 'Limité à',
    '字': 'mots',
    '还可输入': 'Encore saisissable',
    '取消': 'Annuler',
    '删除': 'Supprimer',
    '提示': 'Astuce',
    '清空': 'Vider',
    '校验失败！': 'Erreur de validation !',
    '上一页': 'Précédent',
    '下一页': 'Suivant',
    '每页显示': 'Afficher par page',
    '共': 'Total',
    '跳至': 'Aller à',
    '页': 'pages',
    '条': 'éléments',
    '暂无匹配数据': 'Aucune correspondance',
    '详细': 'Détails',
    '日': 'Dim',
    '一': 'Lun',
    '二': 'Mar',
    '三': 'Mer',
    '四': 'Jeu',
    '五': 'Ven',
    '六': 'Sam',
    '年': 'Année',
    '1月': 'janv',
    '2月': 'févr',
    '3月': 'mars',
    '4月': 'avr',
    '5月': 'mai',
    '6月': 'juin',
    '7月': 'juil',
    '8月': 'août',
    '9月': 'sept',
    '10月': 'oct',
    '11月': 'nov',
    '12月': 'déc',
    '一月': 'janvier',
    '二月': 'février',
    '三月': 'mars',
    '四月': 'avril',
    '五月': 'mai',
    '六月': 'juin',
    '七月': 'juillet',
    '八月': 'août',
    '九月': 'septembre',
    '十月': 'octobre',
    '十一月': 'novembre',
    '十二月': 'décembre',
    '加载中...': 'Chargement...'
  },
  // 韩语
  kokr: {
    '请选择': '선택하세요',
    '确定': '확인',
    '更多': '더보기',
    '收起': '접기',
    '展开': '펼치기',
    '暂无数据': '데이터 없음',
    '限': '제한',
    '字': '자',
    '还可输入': '입력 가능',
    '取消': '취소',
    '删除': '삭제',
    '提示': '안내',
    '清空': '비우기',
    '校验失败！': '유효성 검사 실패!',
    '上一页': '이전',
    '下一页': '다음',
    '每页显示': '페이지당 표시',
    '共': '전체',
    '跳至': '이동',
    '页': '페이지',
    '条': '건',
    '暂无匹配数据': '일치하는 데이터 없음',
    '详细': '상세',
    '日': '일',
    '一': '월',
    '二': '화',
    '三': '수',
    '四': '목',
    '五': '금',
    '六': '토',
    '年': '년',
    '1月': '1월',
    '2月': '2월',
    '3月': '3월',
    '4月': '4월',
    '5月': '5월',
    '6月': '6월',
    '7月': '7월',
    '8月': '8월',
    '9月': '9월',
    '10月': '10월',
    '11月': '11월',
    '12月': '12월',
    '一月': '1월',
    '二月': '2월',
    '三月': '3월',
    '四月': '4월',
    '五月': '5월',
    '六月': '6월',
    '七月': '7월',
    '八月': '8월',
    '九月': '9월',
    '十月': '10월',
    '十一月': '11월',
    '十二月': '12월',
    '加载中...': '로딩 중...'
  },
  // 印尼语
  idid: {
    '请选择': 'Pilih',
    '确定': 'OK',
    '更多': 'Lainnya',
    '收起': 'Ciutkan',
    '展开': 'Bentangkan',
    '暂无数据': 'Tidak ada data',
    '限': 'Dibatasi hingga',
    '字': 'kata',
    '还可输入': 'Masih bisa masukkan',
    '取消': 'Batal',
    '删除': 'Hapus',
    '提示': 'Petunjuk',
    '清空': 'Kosongkan',
    '校验失败！': 'Validasi gagal!',
    '上一页': 'Sebelumnya',
    '下一页': 'Berikutnya',
    '每页显示': 'Tampil per halaman',
    '共': 'Total',
    '跳至': 'Loncat ke',
    '页': 'halaman',
    '条': 'baris',
    '暂无匹配数据': 'Tidak ada data yang cocok',
    '详细': 'Detail',
    '日': 'Min',
    '一': 'Sen',
    '二': 'Sel',
    '三': 'Rab',
    '四': 'Kam',
    '五': 'Jum',
    '六': 'Sab',
    '年': 'tahun',
    '1月': 'Jan',
    '2月': 'Feb',
    '3月': 'Mar',
    '4月': 'Apr',
    '5月': 'Mei',
    '6月': 'Jun',
    '7月': 'Jul',
    '8月': 'Agu',
    '9月': 'Sep',
    '10月': 'Okt',
    '11月': 'Nov',
    '12月': 'Des',
    '一月': 'Januari',
    '二月': 'Februari',
    '三月': 'Maret',
    '四月': 'April',
    '五月': 'Mei',
    '六月': 'Juni',
    '七月': 'Juli',
    '八月': 'Agustus',
    '九月': 'September',
    '十月': 'Oktober',
    '十一月': 'November',
    '十二月': 'Desember',
    '加载中...': 'Memuat...'
  },
  // 德语
  dede: {
    '请选择': 'Bitte wählen',
    '确定': 'OK',
    '更多': 'Mehr',
    '收起': 'Einklappen',
    '展开': 'Aufklappen',
    '暂无数据': 'Keine Daten',
    '限': 'Begrenzt auf',
    '字': 'Zeichen',
    '还可输入': 'Noch eingebbar',
    '取消': 'Abbrechen',
    '删除': 'Löschen',
    '提示': 'Hinweis',
    '清空': 'Leeren',
    '校验失败！': 'Validierung fehlgeschlagen!',
    '上一页': 'Zurück',
    '下一页': 'Weiter',
    '每页显示': 'Pro Seite anzeigen',
    '共': 'Gesamt',
    '跳至': 'Gehe zu',
    '页': 'Seiten',
    '条': 'Einträge',
    '暂无匹配数据': 'Keine passenden Daten',
    '详细': 'Details',
    '日': 'So',
    '一': 'Mo',
    '二': 'Di',
    '三': 'Mi',
    '四': 'Do',
    '五': 'Fr',
    '六': 'Sa',
    '年': 'Jahr',
    '1月': 'Jan',
    '2月': 'Feb',
    '3月': 'Mär',
    '4月': 'Apr',
    '5月': 'Mai',
    '6月': 'Jun',
    '7月': 'Jul',
    '8月': 'Aug',
    '9月': 'Sep',
    '10月': 'Okt',
    '11月': 'Nov',
    '12月': 'Dez',
    '一月': 'Januar',
    '二月': 'Februar',
    '三月': 'März',
    '四月': 'April',
    '五月': 'Mai',
    '六月': 'Juni',
    '七月': 'Juli',
    '八月': 'August',
    '九月': 'September',
    '十月': 'Oktober',
    '十一月': 'November',
    '十二月': 'Dezember',
    '加载中...': 'Laden...'
  },
  // 意大利语
  itit: {
    '请选择': 'Seleziona',
    '确定': 'OK',
    '更多': 'Altro',
    '收起': 'Comprimi',
    '展开': 'Espandi',
    '暂无数据': 'Nessun dato',
    '限': 'Limite di',
    '字': 'caratteri',
    '还可输入': 'Puoi inserire ancora',
    '取消': 'Annulla',
    '删除': 'Elimina',
    '提示': 'Suggerimento',
    '清空': 'Svuota',
    '校验失败！': 'Validazione fallita!',
    '上一页': 'Precedente',
    '下一页': 'Successivo',
    '每页显示': 'Mostra per pagina',
    '共': 'Totale',
    '跳至': 'Vai a',
    '页': 'pagine',
    '条': 'elementi',
    '暂无匹配数据': 'Nessun dato corrispondente',
    '详细': 'Dettagli',
    '日': 'Dom',
    '一': 'Lun',
    '二': 'Mar',
    '三': 'Mer',
    '四': 'Gio',
    '五': 'Ven',
    '六': 'Sab',
    '年': 'anno',
    '1月': 'gen',
    '2月': 'feb',
    '3月': 'mar',
    '4月': 'apr',
    '5月': 'mag',
    '6月': 'giu',
    '7月': 'lug',
    '8月': 'ago',
    '9月': 'set',
    '10月': 'ott',
    '11月': 'nov',
    '12月': 'dic',
    '一月': 'gennaio',
    '二月': 'febbraio',
    '三月': 'marzo',
    '四月': 'aprile',
    '五月': 'maggio',
    '六月': 'giugno',
    '七月': 'luglio',
    '八月': 'agosto',
    '九月': 'settembre',
    '十月': 'ottobre',
    '十一月': 'novembre',
    '十二月': 'dicembre',
    '加载中...': 'Caricamento...'
  },
  // 西班牙语
  eses: {
    '请选择': 'Seleccionar',
    '确定': 'Aceptar',
    '更多': 'Más',
    '收起': 'Contraer',
    '展开': 'Expandir',
    '暂无数据': 'Sin datos',
    '限': 'Límite de',
    '字': 'caracteres',
    '还可输入': 'Aún puede ingresar',
    '取消': 'Cancelar',
    '删除': 'Eliminar',
    '提示': 'Aviso',
    '清空': 'Vaciar',
    '校验失败！': '¡Error de validación!',
    '上一页': 'Anterior',
    '下一页': 'Siguiente',
    '每页显示': 'Mostrar por página',
    '共': 'Total',
    '跳至': 'Ir a',
    '页': 'páginas',
    '条': 'registros',
    '暂无匹配数据': 'No hay coincidencias',
    '详细': 'Detalles',
    '日': 'Dom',
    '一': 'Lun',
    '二': 'Mar',
    '三': 'Mié',
    '四': 'Jue',
    '五': 'Vie',
    '六': 'Sáb',
    '年': 'Año',
    '1月': 'ene',
    '2月': 'feb',
    '3月': 'mar',
    '4月': 'abr',
    '5月': 'may',
    '6月': 'jun',
    '7月': 'jul',
    '8月': 'ago',
    '9月': 'sep',
    '10月': 'oct',
    '11月': 'nov',
    '12月': 'dic',
    '一月': 'enero',
    '二月': 'febrero',
    '三月': 'marzo',
    '四月': 'abril',
    '五月': 'mayo',
    '六月': 'junio',
    '七月': 'julio',
    '八月': 'agosto',
    '九月': 'septiembre',
    '十月': 'octubre',
    '十一月': 'noviembre',
    '十二月': 'diciembre',
    '加载中...': 'Cargando...'
  },
  // 葡萄牙语
  ptpt: {
    '请选择': 'Selecione',
    '确定': 'OK',
    '更多': 'Mais',
    '收起': 'Recolher',
    '展开': 'Expandir',
    '暂无数据': 'Nenhum dado',
    '限': 'Limite de',
    '字': 'caracteres',
    '还可输入': 'Ainda pode inserir',
    '取消': 'Cancelar',
    '删除': 'Excluir',
    '提示': 'Dica',
    '清空': 'Limpar',
    '校验失败！': 'Erro de validação!',
    '上一页': 'Anterior',
    '下一页': 'Próximo',
    '每页显示': 'Exibir por página',
    '共': 'Total',
    '跳至': 'Ir para',
    '页': 'páginas',
    '条': 'itens',
    '暂无匹配数据': 'Nenhum dado correspondente',
    '详细': 'Detalhes',
    '日': 'Dom',
    '一': 'Seg',
    '二': 'Ter',
    '三': 'Qua',
    '四': 'Qui',
    '五': 'Sex',
    '六': 'Sáb',
    '年': 'Ano',
    '1月': 'Jan',
    '2月': 'Fev',
    '3月': 'Mar',
    '4月': 'Abr',
    '5月': 'Mai',
    '6月': 'Jun',
    '7月': 'Jul',
    '8月': 'Ago',
    '9月': 'Set',
    '10月': 'Out',
    '11月': 'Nov',
    '12月': 'Dez',
    '一月': 'Janeiro',
    '二月': 'Fevereiro',
    '三月': 'Março',
    '四月': 'Abril',
    '五月': 'Maio',
    '六月': 'Junho',
    '七月': 'Julho',
    '八月': 'Agosto',
    '九月': 'Setembro',
    '十月': 'Outubro',
    '十一月': 'Novembro',
    '十二月': 'Dezembro',
    '加载中...': 'Carregando...'
  },
  // 俄语
  ruru: {
    '请选择': 'Выберите',
    '确定': 'OK',
    '更多': 'Ещё',
    '收起': 'Свернуть',
    '展开': 'Развернуть',
    '暂无数据': 'Нет данных',
    '限': 'Ограничение',
    '字': 'символов',
    '还可输入': 'Можно ввести ещё',
    '取消': 'Отмена',
    '删除': 'Удалить',
    '提示': 'Подсказка',
    '清空': 'Очистить',
    '校验失败！': 'Ошибка проверки!',
    '上一页': 'Назад',
    '下一页': 'Вперёд',
    '每页显示': 'Показать на странице',
    '共': 'Всего',
    '跳至': 'Перейти к',
    '页': 'стр.',
    '条': 'записей',
    '暂无匹配数据': 'Нет совпадений',
    '详细': 'Подробно',
    '日': 'Вс',
    '一': 'Пн',
    '二': 'Вт',
    '三': 'Ср',
    '四': 'Чт',
    '五': 'Пт',
    '六': 'Сб',
    '年': 'год',
    '1月': 'янв',
    '2月': 'фев',
    '3月': 'мар',
    '4月': 'апр',
    '5月': 'май',
    '6月': 'июн',
    '7月': 'июл',
    '8月': 'авг',
    '9月': 'сен',
    '10月': 'окт',
    '11月': 'ноя',
    '12月': 'дек',
    '一月': 'Январь',
    '二月': 'Февраль',
    '三月': 'Март',
    '四月': 'Апрель',
    '五月': 'Май',
    '六月': 'Июнь',
    '七月': 'Июль',
    '八月': 'Август',
    '九月': 'Сентябрь',
    '十月': 'Октябрь',
    '十一月': 'Ноябрь',
    '十二月': 'Декабрь',
    '加载中...': 'Загрузка...'
  },
  // 阿拉伯语
  arsa: {
    '请选择': 'يرجى التحديد',
    '确定': 'موافق',
    '更多': 'المزيد',
    '收起': 'طي',
    '展开': 'توسيع',
    '暂无数据': 'لا توجد بيانات',
    '限': 'محدود بـ',
    '字': 'كلمة',
    '还可输入': 'يمكن أيضًا إدخال',
    '取消': 'إلغاء',
    '删除': 'حذف',
    '提示': 'تلميح',
    '清空': 'إفراغ',
    '校验失败！': 'فشل التحقق!',
    '上一页': 'السابق',
    '下一页': 'التالي',
    '每页显示': 'عرض لكل صفحة',
    '共': 'الإجمالي',
    '跳至': 'انتقل إلى',
    '页': 'صفحات',
    '条': 'قوائم',
    '暂无匹配数据': 'لا توجد بيانات مطابقة',
    '详细': 'التفاصيل',
    '日': 'الأحد',
    '一': 'الإثنين',
    '二': 'الثلاثاء',
    '三': 'الأربعاء',
    '四': 'الخميس',
    '五': 'الجمعة',
    '六': 'السبت',
    '年': 'سنة',
    '1月': 'يناير',
    '2月': 'فبراير',
    '3月': 'مارس',
    '4月': 'أبريل',
    '5月': 'مايو',
    '6月': 'يونيو',
    '7月': 'يوليو',
    '8月': 'أغسطس',
    '9月': 'سبتمبر',
    '10月': 'أكتوبر',
    '11月': 'نوفمبر',
    '12月': 'ديسمبر',
    '一月': 'يناير',
    '二月': 'فبراير',
    '三月': 'مارس',
    '四月': 'أبريل',
    '五月': 'مايو',
    '六月': 'يونيو',
    '七月': 'يوليو',
    '八月': 'أغسطس',
    '九月': 'سبتمبر',
    '十月': 'أكتوبر',
    '十一月': 'نوفمبر',
    '十二月': 'ديسمبر',
    '加载中...': 'جار التحميل...'
  },
  // 老挝语
  lola: {
    '请选择': 'ກະລຸນາເລືອກ',
    '确定': 'ຕົກລົງ',
    '更多': 'ເພີ່ມເຕີມ',
    '收起': 'ຫຍໍ້',
    '展开': 'ຂະຫຍາຍ',
    '暂无数据': 'ບໍ່ມີຂໍ້ມູນ',
    '限': 'ຈຳກັດທີ່',
    '字': 'ຕົວອັກສອນ',
    '还可输入': 'ຍັງສາມາດໃສ່ເພີ່ມ',
    '取消': 'ຍົກເລີກ',
    '删除': 'ລຶບ',
    '提示': 'ແຈ້ງເຕືອນ',
    '清空': 'ລ້າງ',
    '校验失败！': 'ກວດສອບລົ້ມເຫຼວ!',
    '上一页': 'ກ່ອນໜ້າ',
    '下一页': 'ໜ້າຕໍ່ໄປ',
    '每页显示': 'ສະແດງຕໍ່ໜ້າ',
    '共': 'ລວມ',
    '跳至': 'ຂ້າມໄປ',
    '页': 'ໜ້າ',
    '条': 'ລາຍການ',
    '暂无匹配数据': 'ບໍ່ພົບຂໍ້ມູນທີ່ຕົງກັນ',
    '详细': 'ລາຍລະອຽດ',
    '日': 'ວັນອາທິດ',
    '一': 'ວັນຈັນ',
    '二': 'ວັນອັງຄານ',
    '三': 'ວັນພຸດ',
    '四': 'ວັນພະຫັດ',
    '五': 'ວັນສຸກ',
    '六': 'ວັນເສົາ',
    '年': 'ປີ',
    '1月': 'ມ.ກ.',
    '2月': 'ກ.ພ.',
    '3月': 'ມ.ນ.',
    '4月': 'ມ.ສ.',
    '5月': 'ພ.ພ.',
    '6月': 'ມິ.ຖ.',
    '7月': 'ກ.ລ.',
    '8月': 'ສ.ຫ.',
    '9月': 'ກ.ຍ.',
    '10月': 'ຕ.ລ.',
    '11月': 'ພ.ຈ.',
    '12月': 'ທ.ວ.',
    '一月': 'ມັງກອນ',
    '二月': 'ກຸມພາ',
    '三月': 'ມີນາ',
    '四月': 'ເມສາ',
    '五月': 'ພຶດສະພາ',
    '六月': 'ມິຖຸນາ',
    '七月': 'ກໍລະກົດ',
    '八月': 'ສິງຫາ',
    '九月': 'ກັນຍາ',
    '十月': 'ຕຸລາ',
    '十一月': 'ພະຈິກ',
    '十二月': 'ທັນວາ',
    '加载中...': 'ກຳລັງໂຫຼດ...'
  },
  // 泰语
  thth: {
    '请选择': 'กรุณาเลือก',
    '确定': 'ตกลง',
    '更多': 'เพิ่มเติม',
    '收起': 'ย่อ',
    '展开': 'ขยาย',
    '暂无数据': 'ไม่มีข้อมูล',
    '限': 'จำกัดที่',
    '字': 'คำ',
    '还可输入': 'สามารถป้อนได้อีก',
    '取消': 'ยกเลิก',
    '删除': 'ลบ',
    '提示': 'เคล็ดลับ',
    '清空': 'ล้าง',
    '校验失败！': 'การตรวจสอบล้มเหลว!',
    '上一页': 'ก่อนหน้า',
    '下一页': 'ถัดไป',
    '每页显示': 'แสดงต่อหน้า',
    '共': 'รวม',
    '跳至': 'ข้ามไปที่',
    '页': 'หน้า',
    '条': 'รายการ',
    '暂无匹配数据': 'ไม่พบข้อมูลที่ตรงกัน',
    '详细': 'รายละเอียด',
    '日': 'อา.',
    '一': 'จ.',
    '二': 'อ.',
    '三': 'พ.',
    '四': 'พฤ.',
    '五': 'ศ.',
    '六': 'ส.',
    '年': 'ปี',
    '1月': 'ม.ค.',
    '2月': 'ก.พ.',
    '3月': 'มี.ค.',
    '4月': 'เม.ย.',
    '5月': 'พ.ค.',
    '6月': 'มิ.ย.',
    '7月': 'ก.ค.',
    '8月': 'ส.ค.',
    '9月': 'ก.ย.',
    '10月': 'ต.ค.',
    '11月': 'พ.ย.',
    '12月': 'ธ.ค.',
    '一月': 'มกราคม',
    '二月': 'กุมภาพันธ์',
    '三月': 'มีนาคม',
    '四月': 'เมษายน',
    '五月': 'พฤษภาคม',
    '六月': 'มิถุนายน',
    '七月': 'กรกฎาคม',
    '八月': 'สิงหาคม',
    '九月': 'กันยายน',
    '十月': 'ตุลาคม',
    '十一月': 'พฤศจิกายน',
    '十二月': 'ธันวาคม',
    '加载中...': 'กำลังโหลด...'
  }
}

var locale = null
var getlang = function (key) {
  // 如果url里带参数则直接用
  if (!locale) {
    var _locale = ''
    if (window._cb && window._cb.lang.lang) {
      _locale = window._cb.lang.lang
    } else if (window.cb && window.cb.lang && window.cb.lang.lang) {
      _locale = window.cb.lang.lang
    } else if (window.lang && window.lang.lang) {
      _locale = window.lang.lang
    } else {
      try {
        _locale = userContext.getLangLocale()
      } catch (e) {
        // do nothing
      }
    }
    if (_locale) {
      locale = _locale.replace('-', '').replace('_', '').toLowerCase()
    }
  }
  // if (document.cookie.indexOf('u_locale=en_US') >= 0) {
  //   locale = 'enus'
  // }
  // 如果没有设置默认值
  if (!locale) {
    locale = 'zhcn'
  }
  if (locale !== 'zhcn') {
    if (lang.hasOwnProperty(locale)) {
      return lang[locale] ? lang[locale][key] : key
    } else {
      return key
    }
  } else {
    return key
  }
}

export default getlang



// WEBPACK FOOTER //
// ./src/i18n/index.js